import { render, staticRenderFns } from "./AboutOne.vue?vue&type=template&id=42e84608&"
import script from "./AboutOne.vue?vue&type=script&lang=js&"
export * from "./AboutOne.vue?vue&type=script&lang=js&"
import style0 from "./AboutOne.vue?vue&type=style&index=0&id=42e84608&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports